import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const statisticsComponentItemStyles = makeStyles((theme: Theme) =>
    createStyles({
        item: {
            padding: "0 15px",
            borderRight: "1px solid rgba(220, 223, 239, 1)",

            "&:last-child": {
                borderRight: "none",
                paddingRight: 0,
            },
        },

        subTitle: {
            paddingBottom: "9px",
            fontSize: "14px",
            lineHeight: "118%",
        },
        data: {
            fontSize: "14px",
            lineHeight: "118%",
        },
    })
);
